import { properCase } from "LIB/formatters/text";

export function toOptions(map, textField = "label") {
  return Object.keys(map).map(t => {
    const text = textField ? map[t][textField] : map[t];
    return { value: t, text };
  });
}

export function arrayToOptions(map) {
  return map.map(text => ({ value: text, text }));
}

export function arrayToProperCasedOptions(map) {
  return map.map(text => ({ value: text, text: properCase(text) }));
}

export function arrayToProperCasedOptionsWithCurrentValue(map, currentValue) {
  if (!currentValue || map.includes(currentValue)) {
    return map.map(text => ({ value: text, text: properCase(text) }));
  }

  return map
    .map(text => ({ value: text, text: properCase(text) }))
    .concat([{ value: currentValue, text: properCase(currentValue) }]);
}

export function arrayToManipulatedOptions(map, func = properCase) {
  return map.map(text => ({ value: text, text: func(text) }));
}

export function addressesToOptions(addresses) {
  const formatted = ({
    line1,
    line2,
    city,
    state,
    postal_code: zip,
    country,
    care_of: co
  }) =>
    `${co ? `c/o ${co}, ` : ""}${line1}${line2
      ? ` ${line2}`
      : ""}, ${city}, ${state} ${zip}, ${country}`; // eslint-disable-line prefer-template

  return addresses.map(a => ({
    value: a.id,
    text: formatted(a)
  }));
}



// WEBPACK FOOTER //
// ./app/lib/forms.js